export default __webpack_public_path__ + "static/media/icon_member.5b3aa91f.svg";